var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{key:_vm.$route.fullPath}),_c('div',{staticClass:"service_wrap"},[_c('div',{staticClass:"qrcode_wrap"},[_c('div',{ref:"qrCodeUrl",staticClass:"qrcode"}),_c('p',[_vm._v("微信扫一扫")])]),_vm._m(0)])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn_wrap"},[_c('i',{staticClass:"iconfont icon-kefu"}),_c('p',[_vm._v("客服")])])
}]

export { render, staticRenderFns }